import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ax-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.less']
})
export class PanelComponent implements OnInit {

  /**
   * Título do header do painel.
   */
  @Input()
  title: string = '';

  /**
   * Padding do corpo do painel.
   */
  @Input()
  padding: string = '15px';

  /**
   * Insere classe conteúdo no corpo do painel.
   */
  @Input()
  minHeight: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

}
